<template>
  <div>
    <b-button @click="newLocation()">Nouveau lieu</b-button>
    <b-table striped hover :items="locations" :fields="fields" 
      @row-clicked="updateLocation">
    </b-table>
    
    <b-modal v-model="show" id="locationModal" title="Créer/modifier un lieu">
      <b-form @submit="onSubmit" >
        <b-form-group
          label="Nom :"
          label-for="nom">
          <b-form-input 
            id="nom"
            type="text"
            v-model="location.name"
            required />
        </b-form-group>
        <b-form-group
          label="Coordonnées/Adresse :"
          label-for="maps">
          <b-form-input 
            id="maps"
            type="text"
            v-model="location.maps"
            placeholder="Ex: 47.285318, -1.482603 ou Salle De La Picaudiere"
            required
            />
        </b-form-group>
        
        <b-button class="login-submit" type="submit" variant="primary">Créer/modifier</b-button>
        <b-button class="login-submit" type="button" v-if="location.id" variant="danger" @click="deleteLocation">Supprimer</b-button>
      </b-form>
      <div slot="modal-footer">
      </div>
    </b-modal>
    
    <b-modal v-model="okModal" title="Sauvegardé" ok-only>
      <div>
        Lieu sauvegardé
      </div>
    </b-modal>
    <b-modal v-model="okDeleteModal" title="Supprimé" ok-only>
      <div>
        Lieu supprimé
      </div>
    </b-modal>
    <b-modal v-model="errorModal" title="Oups !!!" ok-only>
      <div>
        <p>Une erreur est survenue :</p>
        <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'AdminLocations',
  data() {
    return {
      locations: [],
      location: {},
      show: false,
      okModal: false,
      okDeleteModal: false,
      errorModal: false,
      errorMessage: '',
      creationMode: true,
      fields: [
        { key: 'name', label: 'Nom' },
        { key: 'maps', label: 'Coordonnées/Adresse' }
      ]
    }
  },
  mounted() {
    this.loadLocations()
  },
  methods: {
    loadLocations() {
      Vue.$backend.listLocations().then((locations) => {
        this.locations = locations
      }).catch((error) => {
        console.error('Error loading locations:', error)
        this.errorMessage = this.extractErrorMessage(error)
        this.errorModal = true
      })
    },
    
    newLocation() {
      this.location = {
        name: '',
        maps: ''
      }
      this.creationMode = true
      this.show = true
    },
    
    updateLocation(location) {
      this.location = { ...location }
      this.creationMode = false
      this.show = true
    },
    
    onSubmit(evt) {
      evt.preventDefault()
      
      if (this.creationMode) {
        Vue.$backend.createLocation(this.location).then((id) => {
          this.location.id = id
          this.okModal = true
          this.show = false
          this.loadLocations()
        }).catch((error) => {
          console.error('Error creating location:', error)
          this.errorMessage = this.extractErrorMessage(error)
          this.errorModal = true
        })
      } else {
        Vue.$backend.updateLocation(this.location).then(() => {
          this.okModal = true
          this.show = false
          this.loadLocations()
        }).catch((error) => {
          console.error('Error updating location:', error)
          this.errorMessage = this.extractErrorMessage(error)
          this.errorModal = true
        })
      }
    },
    
    deleteLocation() {
      if (confirm('Êtes-vous sûr de vouloir supprimer ce lieu ?')) {
        Vue.$backend.deleteLocation(this.location.id).then(() => {
          this.okDeleteModal = true
          this.show = false
          this.loadLocations()
        }).catch((error) => {
          console.error('Error deleting location:', error)
          this.errorMessage = this.extractErrorMessage(error)
          this.errorModal = true
        })
      }
    },
    
    extractErrorMessage(error) {
      if (error.body && error.body.error) {
        return error.body.error
      } else if (error.statusText) {
        return error.statusText
      } else if (error.message) {
        return error.message
      } else {
        return 'Erreur inconnue'
      }
    }
  }
}
</script>

<style scoped>
.login-submit {
  margin-right: 10px;
}
</style>
